import { Injectable } from '@angular/core';
import { LabelContext } from '../models/LabelContext';
import { EndPointService } from 'src/app/core/services/end-point.service';
import { Label } from '../models/Label';
import { Observable, of } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class LabelService {
  private _baseUrl = '/api/labels/';
  private _page = 'page';
  private _pagepublic = 'pagepublic';

  private _context: LabelContext;
  private _contextCache = {};
  private _contextRequestsCache = {};
  private _labels$: Observable<Label[]>;
  private _labelrequests$ = {};

  public constructor(private _endPointService: EndPointService) {
    this.registerEndPoints();
  }

  private registerEndPoints(): void {
    this._endPointService.registerEndPoint<Label[]>(
      'label_page_get',
      `${this._baseUrl}${this._page}`,
      true
    );

    this._endPointService.registerEndPoint<Label[]>(
      'label_page_get_public',
      `${this._baseUrl}${this._pagepublic}`,
      true
    );
  }

  public refreshPageNameInCache(pageName: string): Observable<LabelContext> {
    this._contextRequestsCache[pageName] = null;
    return this.updateObservable(pageName, false, null);
  }

  private updateObservable(
    pageName: string,
    isPublic: boolean,
    languageId?: number
  ): Observable<LabelContext> {
    pageName = pageName ? pageName.toLowerCase() : pageName; // FA
    if (this._contextRequestsCache[pageName]) {
      this._labels$ = this._contextRequestsCache[pageName];
      // return this._contextRequestsCache[pageName].pipe(
      //   map(() => {
      //     return this._context;
      //   })
      // );
    } else {
      this._labels$ = this._endPointService.call<Label[]>(
        isPublic ? 'label_page_get_public' : 'label_page_get',
        { pageName, languageId },
        true
      ).pipe(
        // Share the same HTTP request across all concurrent subscribers for this label context.
        shareReplay(1)
      );

      this._contextRequestsCache[pageName] = this._labels$;
    }

    return this._labels$.pipe(
      // tap((labels: Label[]) => {
      //   this._contextCache[pageName] = new LabelContext(pageName, labels);
      //   this._context = this._contextCache[pageName];
      // }),
      map((labels: Label[]) => {
        this._contextCache[pageName] = new LabelContext(pageName, labels);
        this._context = this._contextCache[pageName];
        return this._context;
      })
    );
  }

  public getContextName(): string {
    if (this._context && this._context.name) {
      return this._context.name.toLowerCase();
    }
  }

  public getContext(pageName?: string): Observable<LabelContext> {
    if (this._context && !pageName) {
      return of(this._context);
    }
    if (pageName && this._contextCache[pageName]) {
      return of(this._contextCache[pageName]);
    }

    return this.updateObservable(pageName, false);
  }


  public switchContext(
    pageName: string,
    isPublic = false,
    languageId?: number
  ): Observable<LabelContext> {
    pageName = pageName ? pageName.toLowerCase() : pageName; // FA
    if (!this._context || this._context.name !== pageName) {
      if (!this._contextCache[pageName]) {
        return this.updateObservable(pageName, isPublic, languageId);
      } else {
        this._context = this._contextCache[pageName];
        return of(this._context);
      }
    }
    return of(null);
  }

  public getLabel(
    labelName: string,
    context?: string,
    isPublic = false
  ): Observable<Label> {
    labelName = labelName.toLowerCase(); // FA

    if (context) {
      context = context.toLowerCase();
    }

    let contextToAccess: Observable<LabelContext>;

    if (this._context && (!context || context === this._context.name)) {
      contextToAccess = of(this._context);
      // return this._context.get(labelName);
    } else if (context && context.length) {
      contextToAccess = this.switchContext(context, isPublic, null);
    }

    if (contextToAccess) {
      return contextToAccess.pipe(
        map((ctx) => {
          return ctx.get(labelName);
        })
      );
    }

    return null;
  }
  public getPublicCandidateLabel(
    labelName: string,
    context: string,
    languageId?: number
  ): Observable<Label> {
    labelName = labelName.toLowerCase(); // FA

    if (context) {
      context = context.toLowerCase();
    }

    let contextToAccess: Observable<LabelContext>;

    if (this._context && (!context || context === this._context.name)) {
      contextToAccess = of(this._context);
      // return this._context.get(labelName);
    } else if (context && context.length) {
      contextToAccess = this.switchContext(context, true, languageId);
    }

    if (contextToAccess) {
      return contextToAccess.pipe(
        map((ctx) => {
          return ctx.get(labelName);
        })
      );
    }

    return null;
  }
}
